<div mat-dialog-content>
  <h2>Statut des commandes (de la livraison)</h2>
  <p *ngIf="data">
    <span class="state-circle state-circle-AS"></span>
    <b>A saisir :</b> la commande et ses inventaires si nécessaire ont été pré-initialisé, il faut que vous renseignés
    les quantités.
  </p>

  <p *ngIf="!data">
    <span class="state-circle state-circle-AS"></span>
    <b>A saisir :</b> la commande a été pré-initialisé, il faut que vous renseignés les quantités.
  </p>

  <p *ngIf="data">
    <span class="state-circle state-circle-EA"></span>
    <b>En attente :</b> les inventaires liés à la commande ont été renseignées et enregistrées mais n'ont pas été
    validés
  </p>

  <p *ngIf="data">
    <span class="state-circle state-circle-AT"></span>
    <b>A transmettre :</b> la commande est prête à être transmise, les inventaires ne sont plus modifiables.
  </p>

  <p *ngIf="!data">
    <span class="state-circle state-circle-AT"></span>
    <b>A transmettre :</b> la commande est prête à être transmise.
  </p>

  <p>
    <span class="state-circle state-circle-AS12H"></span>
    <b>A saisir avant 12h :</b> vous avez reçu un mail de rappel, vous indiquant que la commande doit être
    renseignée et transmise avant 12h pour qu'elle soit prise en compte pour la date de livraison indiquée. Après 12h,
    sans action de votre
    part, elle passera au statut « délai dépassé » et il n'y aura pas de livraison.
  </p>

  <p>
    <span class="state-circle state-circle-AT12H"></span>
    <b>A transmettre avant 12h :</b> vous avez reçu un mail de rappel, vous indiquant que la commande doit être
    transmise avant 12h pour qu'elle soit prise en compte pour la date de livraison indiquée. Après 12h, sans action de
    votre
    part, elle passera au statut « délai dépassé » et il n'y aura pas de livraison.
  </p>

  <p>
    <span class="state-circle state-circle-T"></span>
    <b>Transmise :</b> la commande a été transmise à ANETT, elle n'est plus modifiable.
    Si vous souhaitez ajouter une nouvelle commande pour cette date de livraison, vous devez cliquer sur « Ajouter une
    Commande ».
  </p>

  <p>
    <span class="state-circle state-circle-T0"></span>
    <b>Transmis à 0 :</b> la case « Pas de Commande » a été cochée et la commande a été transmise à ANETT, il n'y aura
    aucune livraison pour la date de livraison indiquée.
  </p>

  <p>
    <span class="state-circle state-circle-DD"></span>
    <b>Délai Dépassé :</b> la commande n'a pas été transmise, dans les temps, à ANETT, il n'y aura aucune livraison pour
    la date de livraison indiquée.
  </p>

  <div *ngIf="data">
    <h2>Statut des inventaires</h2>
    <p>
      <span class="state-circle state-circle-AS"></span>
      <b>A saisir :</b> l'inventaire est pré-initialisé par lingerie, vous devez renseigner la colonne « restant » par
      articles.
    </p>

    <p>
      <span class="state-circle state-circle-EC"></span>
      <b>En cours :</b> tous les articles n'ont pas de quantité restante de renseignée.
    </p>

    <p>
      <span class="state-circle state-circle-R"></span>
      <b>Renseigné :</b> toutes les quantités restantes sont renseignées, mais l'inventaire n'est pas validé.
    </p>

    <p>
      <span class="state-circle state-circle-V"></span>
      <b>Validé :</b> l'inventaire a été validé, il n'est plus modifiable.
    </p>
  </div>
</div>
<div class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Retour</button>
</div>